import { callApi, LONG_API_TIMEOUT_MS } from './ApiClient';

const getAddress = (data, dispatch) => {
  return callApi('GET', `/addresses`, data, dispatch);
}

const postAddress = (data, dispatch) => {
  // 一括登録でサーバー側がset_time_limit(3600)される重いAPIのため長めに設定する
  return callApi('POST', `/addresses`, data, dispatch, false, {
    timeout: LONG_API_TIMEOUT_MS,
  });
}

const getAddressById = (id, data, dispatch) => {
  return callApi('GET', `/addresses/${id}`, data, dispatch);
}

const putAddressById = (data, dispatch) => {
  return callApi('PUT', `/addresses/${data.id}`, data, dispatch);
}

const patchAddressById = (data, dispatch) => {
  return callApi('PATCH', `/addresses/${data.id}`, data, dispatch);
}

const deleteAddress = (data, dispatch) => {
  // 本来はDELETEだが、CORS対策によるOPTIONSとなる問題を解決出来ないため、一旦POSTで逃げる
  return callApi('POST', `/addresses/deleteMulti`, data, dispatch);
}

const putAddressTagMulti = (data, dispatch) => {
  return callApi('PUT', '/addresses/tags/updateMulti', data, dispatch);
}

const putAddressesTagsDeleteMulti = (data, dispatch) => {
  return callApi('PUT', '/addresses/tags/deleteMulti', data, dispatch);
}

const putAddressesTagsUpdateTagNameMulti = (data, dispatch) => {
  return callApi('PUT', '/addresses/tags/updateTagNameMulti', data, dispatch);
}

const getErrorAddress = (data, dispatch) => {
  return callApi('GET', '/error-addresses', data, dispatch);
}

const getWarningAddress = (data, dispatch) => {
  return callApi('GET', '/warning-addresses', data, dispatch);
}

const deleteErrorAddressById = (id, dispatch) => {
  return callApi('DELETE', `/error-addresses/${id}`, null, dispatch);
}

const deleteErrorAddressMulti = (data, dispatch) => {
  return callApi('POST', `/error-addresses/deleteMulti`, data, dispatch);
}

const deleteWarningAddressById = (id, dispatch) => {
  return callApi('DELETE', `/warning-addresses/${id}`, null, dispatch);
}

const deleteWarningAddressMulti = (data, dispatch) => {
  return callApi('POST', `/warning-addresses/deleteMulti`, data, dispatch);
}

const getSendAddressesConfirm = (data, dispatch) => {
  return callApi('GET', `/addresses/confirm/send_addresses`, data, dispatch);
}

const getOrderedFollowCallConfirm = (data, dispatch) => {
  return callApi('GET', `/addresses/confirm/ordered_follow_call`, data, dispatch);
}

const postErrorAddress = (data, dispatch) => {
  return callApi('POST', `/error-addresses/${data.id}`, data, dispatch);
}

const postWarningAddress = (data, dispatch) => {
  return callApi('POST', `/warning-addresses/${data.id}`, data, dispatch);
}

const postWarningAddressRestore = (data, dispatch) => {
  return callApi('POST', `/warning-addresses/${data.id}/restore`, data, dispatch);
}

const getAddressTags = (data, dispatch) => {
  return callApi('GET', `/addresses/tags`, data, dispatch);
}

const getWarningAddressTags = (data, dispatch) => {
  return callApi('GET', `/warning-addresses/tags`, data, dispatch);
}

const putWarningAddressesTagsDeleteMulti = (data, dispatch) => {
  return callApi('PUT', '/warning-addresses/tags/deleteMulti', data, dispatch);
}

const putWarningAddressesTagsUpdateTagNameMulti = (data, dispatch) => {
  return callApi('PUT', '/warning-addresses/tags/updateTagNameMulti', data, dispatch);
}

const getErrorAddressTags = (data, dispatch) => {
  return callApi('GET', `/error-addresses/tags`, data, dispatch);
}

const putErrorAddressesTagsDeleteMulti = (data, dispatch) => {
  return callApi('PUT', '/error-addresses/tags/deleteMulti', data, dispatch);
}

const putErrorAddressesTagsUpdateTagNameMulti = (data, dispatch) => {
  return callApi('PUT', '/error-addresses/tags/updateTagNameMulti', data, dispatch);
}

const getAddressSuggestCorporations = (id, data, dispatch) => {
  return callApi('GET', `/addresses/${id}/suggest-corporations`, data, dispatch)
}

const getWarningAddressSuggestCorporations = (id, data, dispatch) => {
  return callApi('GET', `/warning-addresses/${id}/suggest-corporations`, data, dispatch)
}

const getErrorAddressSuggestCorporations = (id, data, dispatch) => {
  return callApi('GET', `/error-addresses/${id}/suggest-corporations`, data, dispatch)
}

const putAddressLinkCorporation = (data, dispatch) => {
  return callApi('PUT', `/addresses/corporation/updateMulti`, data, dispatch)
}

const postWarningAddressWithExecutivePerson = (id, isReferExecutivePerson, dispatch) => {
  const data = {
    "is_refer_executive_person": isReferExecutivePerson
  }
  return callApi('POST', `/warning-addresses/${id}/save-with-executive-person`, data, dispatch)
}

const postWarningAddressOverwrite = (id, dispatch) => {
  return callApi('POST', `/warning-addresses/${id}/overwrite`, null, dispatch)
}

const postWarningAddressesOverwritemulti = (data, dispatch) => {
  return callApi('POST', `/warning-addresses/overwriteMulti`, data, dispatch)
}

const postAddressesMoveNgSendings = (data, dispatch) => {
  return callApi('POST', `/addresses/move-ng-sendings`, data, dispatch)
}

const postAddressesRestoreNgSendings = (data, dispatch) => {
  return callApi('POST', `/addresses/restore-ng-sendings`, data, dispatch)
}

const getAddressesDemo = (data, dispatch) => {
  return callApi('GET', `/addresses/demo`, data, dispatch)
}

const postWarningAddressesMulti = (data, dispatch) => {
  return callApi('POST', `/warning-addresses`, data, dispatch)
}

const postSalesforceSync = (data, dispatch) => {
  return callApi('POST', `/addresses/salesforce/sync`, data, dispatch);
}

export const AddressBookApi = {
  getAddress,
  getAddressesDemo,
  postAddress,
  getAddressById,
  putAddressById,
  patchAddressById,
  deleteAddress,
  putAddressTagMulti,
  putAddressesTagsDeleteMulti,
  putAddressesTagsUpdateTagNameMulti,
  getErrorAddress,
  getWarningAddress,
  deleteWarningAddressById,
  deleteErrorAddressById,
  deleteErrorAddressMulti,
  deleteWarningAddressMulti,
  getSendAddressesConfirm,
  getOrderedFollowCallConfirm,
  postErrorAddress,
  postWarningAddress,
  postWarningAddressRestore,
  getAddressTags,
  getWarningAddressTags,
  putWarningAddressesTagsDeleteMulti,
  putWarningAddressesTagsUpdateTagNameMulti,
  getErrorAddressTags,
  putErrorAddressesTagsDeleteMulti,
  putErrorAddressesTagsUpdateTagNameMulti,
  getAddressSuggestCorporations,
  getWarningAddressSuggestCorporations,
  getErrorAddressSuggestCorporations,
  putAddressLinkCorporation,
  postWarningAddressWithExecutivePerson,
  postWarningAddressOverwrite,
  postWarningAddressesOverwritemulti,
  postAddressesMoveNgSendings,
  postAddressesRestoreNgSendings,
  postWarningAddressesMulti,
  postSalesforceSync,
};



// WEBPACK FOOTER //
// ./src/redux/api/AddressBookApi.js